import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
//import { DashboardCard, IDashboardCard } from '../../modals/dashboard-card.class';

@Component({
  selector: 'app-detail-container',
  templateUrl: './detail-container.component.html',
  styleUrls: ['./detail-container.component.scss']
})
export class DetailContainerComponent implements OnInit {
  @Input() containerHeaderAction: TemplateRef<HTMLElement>;
  @Input() containerHeader: TemplateRef<HTMLElement>;
  @Input() collapsedContainerHeader: TemplateRef<HTMLElement>;
//  @Input() dashboardCard: DashboardCard = new DashboardCard({} as IDashboardCard);
  @Input() containerClass: string;
  @Input() isCollapsible = true;
  @Input() isCollapsed = false;
  @Input() pullRightOnMobile = true;
  constructor() { }

  ngOnInit(): void {
    if (window.innerWidth < 480) {
      this.isCollapsed = true;
    }
  }

  expandClicked() {
  //  this.isCollapsed = false;
  }
  collapseClicked() {
  //  this.isCollapsed = true;
  }
  panelToggle() {
    //alert(this.dashboardCard.isCollapsed);
    this.isCollapsed = !this.isCollapsed;
    //this.isCollapsed = !this.isCollapsed;
  };
}
